import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Towards a Gatsby+Suspense proof-of-concept",
  "description": "",
  "published": "2019-11-11T00:00:00.000Z",
  "redirect_from": ["/blog/towards-a-gatsbysuspense-proof-of-concept/swizec/9238"],
  "categories": "Front End, Technical",
  "hero": "./img/K6USjWa.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Messing around with React Suspense gave me a great idea: What if you could fallback to preloaded data instead of a loading spinner? 💡`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/36f41201614984955047d1d2b4557311/e5166/K6USjWa.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.81614349775785%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20134v133h401V0H0v134M233%2032l-1%207c0%2014%200%2022-1%2021h-12l-12%201-11%201-1%2010v18c-1%200-1%201-2-14V62l-15-1c-21%200-19-1-19%2013l-1%2012v1l1%202c0%202%200%202-1%201-1-2-1-2-1%200l-2%203-1%206a2419%202419%200%2000-1%2081c0%2017%200%2020%203%2020l6%201c3%200%203%200%204-2l1-3%201-1h-4l-5-1c-1-1-1-1-1%201v2c-1%201-2-3-2-13%200-11%200-11%203-10%203%202%206%200%206-2s-1-3-2-3c-2-1-2-1%201-1s3%200%204%203c0%203%203%204%203%202l-1-1v-1l4-1c5%200%207-2%207-9l3-13%201-9-1-3v3l-9%2020h-3l2-3%203-9%203-10-8-1-10-1c-4-1-2-2%203-2%2013%201%2015%200%2016-3s4-6%208-7v-4l-2-11-1-11c-1-1-1-2%201-2%201-1%201-1%201%201v2c1%201%201%200%201-1l1-3%201%201v1l1-3c0-1%200-2%201-1h3l1%202v6c2%205%202%2014%200%2018s-2%204%203%206c3%201%204%202%205%205l1%205%207-1c5%200%206%200%205%201%200%201-2%202-5%202-7%200-7%200-4%206a1341%201341%200%20016%2011c3%201%204%205%202%205s-9-9-12-16l-4-6%202%2017%202%2011v4h10c12%200%2013%201%201%201-11%201-10%201-9%204%200%203%203%204%205%202s1-3-2-3c-2-1-2-1%201-1s5%201%207%203%203%202%206%202c8-2%207-3%208%208l1%2011%201-1%201-2v-1c-2%200-1-3%201-3v-2c-2-2-3-98-1-103%201-3%201%200%202%2055v49c1%205%203%208%203%204a220%20220%200%20011-21c0-4%201-4%202%200%201%201%201%200%201-2v-18l1-4c0-4%200-4%201%202%201%204%201%203%201-6l-1-8-1%204-1-4%202-10v-18c-1-1-2-8%200-7l1-2-1-3-1-3-1-4-1-3c0-2%200-2%202-1%201%202%201%202%201-1s-1-5-2-3c-1%201-1-3-1-8%200-8%200-9-3-11l-2-2v7l-1%2014c-1%200-2-10-1-11V56l-1-13c0-12-1-17-2-11m-78%2015l-1%207c-2%204-2%205-4%204-3%200-3%200-2%202%200%202%200%202-1%201-1-2-1-2-2%200%200%202-1%202-2%201s-1-1-1%201l-1-3-2-6v4a593%20593%200%20003%2083c1-2%202%201%201%206l1%202%201%202%201%204%201%202c-1%203%200%205%201%204v5a657%20657%200%20001-47%20411%20411%200%20014-54l1%202%201%202-2%208c0%207%201%208%202%208a275%20275%200%20000-38m29%203c-2%201-3%202-3%205s0%203%203%203l4-1h7c4%200%205%200%204-1l-1-1%202-2c0-2-2-3-2-1h-2l-1-1-2%201h-1l-2-1-2-1h-4m-54%209l-2%2016c0%203%200%204-1%203s-1%200-1%204v2c-1-3-1-3-2%202l-2%206a96%2096%200%20001%2028l1%205%201%205%201%204c1%200%202-1%202-3v-7c0-7%202-3%202%205l1%2010%201%203v-3a947%20947%200%2000-2-80m-17%201a191%20191%200%20002%2042c-2%207-2%2019-2%2026l1%207v-8c1-5%201-7%202-5l1%202v-2l1-14a195%20195%200%20012-26l1-2%201-6c0-4%201-5%202-5l1-2c0-2-1-3-2-3-2%200-2%201-2%208v8l-1-8c-2-13-3-11-3%203a72%2072%200%2001-1%2019l-1%202-1-19-1-17m181%2019l-1%209-1%2010v14l-4%2029c0%2012%200%2015%202%2014v3a442%20442%200%20000%2059c1%206%201%206%203-4l2-7c0-4%203-6%204-5%202%201%202%2012%201%2012l-1%204c0%204%201%205%202%203h1c0%203%202-1%202-4l2-10c2-5%201-8-1-6l-1-2c0-2-1-3-3-1s-1-4%201-7l2-6%201-11c2%201%203%2011%202%2012-2%202-1%2012%200%2012%202%200%202-1%202-5%200-6%200-9%202-12v-7a724%20724%200%2001-2-10c-2-1-2-1-1-4v-6l2-8-1-4-2-2c0-2%201-3%202-3l1-6c0-6%200-7-2-4v-3l1-8v-4c-2-4-3-1-4%207v8l-2-6v-11c0-4%200-5-1-4l-1%205-1%204-1-14c0-15%200-16-3-14-2%201-2%201-2-2%200-2%200-3%201-2v-4c-1-1-1-1-1%201m-34%204a440%20440%200%20000%2044l1-9%201-18c-1-16-1-20-2-17m-37%2095c0%201-2%202-8%201h-8v4c0%204%200%204%203%204l3-1h4c2%202%207%200%206-2%200-1%200-2%202-1l3-1c2-2%201-3-2-3-2%200-2%200%200-1%201-1%201-1-1-1l-2%201m-56%202c-6%200-8%202-6%205v1c-4%200%207%202%2011%201%207%200%207%200%208-4v-4h-4l-9%201m57%2017c-3%202-6%203-6%201h-11l-3%202v1l9%202%209%201h3l5-2c3-1%204-2%202-2l-4-2-2-3-2%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/36f41201614984955047d1d2b4557311/ca0a1/K6USjWa.webp 223w", "/static/36f41201614984955047d1d2b4557311/75680/K6USjWa.webp 445w", "/static/36f41201614984955047d1d2b4557311/8d1ba/K6USjWa.webp 890w", "/static/36f41201614984955047d1d2b4557311/92f8c/K6USjWa.webp 1200w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/36f41201614984955047d1d2b4557311/853b2/K6USjWa.jpg 223w", "/static/36f41201614984955047d1d2b4557311/0a4fe/K6USjWa.jpg 445w", "/static/36f41201614984955047d1d2b4557311/7f80b/K6USjWa.jpg 890w", "/static/36f41201614984955047d1d2b4557311/e5166/K6USjWa.jpg 1200w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/36f41201614984955047d1d2b4557311/7f80b/K6USjWa.jpg",
              "alt": "K6USjWa",
              "title": "K6USjWa",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`You could leverage Gatsby's approach with React Suspense for a smooth user experience. Load partial data at build time, bake it into the static HTML, then load the rest when a user renders your page.`}</p>
    <p>{`Initial experiments look great, where I'm stuck is loading data for subsequent pages. Let me explain`}</p>
    <p>{`You can see it in action here 👉 `}<a parentName="p" {...{
        "href": "https://gatsby-suspense-poc.now.sh/"
      }}>{`https://gatsby-suspense-poc.now.sh/`}</a></p>
    <p>{`Code on GitHub 👉 `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/gatsby-suspense-poc"
      }}>{`https://github.com/Swizec/gatsby-suspense-poc`}</a></p>
    <h2 {...{
      "id": "gatsby-with-dynamic-data-some-background"
    }}>{`Gatsby with dynamic data, some background`}</h2>
    <p>{`Let's start with background on using Gatsby for dynamic pages.`}</p>
    <p>{`Gatsby is a static site builder. You build a website in React, use GraphQL to connect to data sources, and compile a static HTML page.`}</p>
    <p>{`Your GraphQL queries run at compile time and bake data into your static HTML via hardcoded props. Not quite hardcoded props but close enough.`}</p>
    <p>{`The result is a page that can work offline and loads without API requests. This makes it fast.`}</p>
    <p>{`When your site loads in a browser, however, it becomes a React single page app. `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/react-dom.html#hydrate"
      }}>{`React hydration`}</a>{` means there's no flash of blank content and no need to re-render the HTML.`}</p>
    <p>{`You can add Apollo Client for GraphQL support or use `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{`. It's just a JavaScript app at this point.`}</p>
    <p>{`I like to wrap the root node in ApolloProvider and use `}<a parentName="p" {...{
        "href": "https://github.com/trojanowski/react-apollo-hooks"
      }}>{`react-apollo-hooks`}</a>{` for the rest.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20gatsby-browser.js%0A%2F%2F%20gatsby-ssr.js%0A%0Aimport%20%7B%20client%20%7D%20from%20%22.%2Fsrc%2Fapollo%22%0A%0Aexport%20const%20wrapRootElement%20%3D%20(%7B%20element%20%7D)%20%3D%3E%20(%0A%20%20%3CApolloProvider%20client%3D%7Bclient%7D%3E%7Belement%7D%3C%2FApolloProvider%3E%0A)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "582px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.81165919282511%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'215\\'%20viewBox=\\'0%200%20400%20215\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2034c-2%202-2%20146%200%20148s352%202%20354%200%202-146%200-148-352-2-354%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/387f46d55f3c404b6e8747502b2def56/ca0a1/techletter.app-screenshot-1573495144942.webp 223w", "/static/387f46d55f3c404b6e8747502b2def56/75680/techletter.app-screenshot-1573495144942.webp 445w", "/static/387f46d55f3c404b6e8747502b2def56/f6aeb/techletter.app-screenshot-1573495144942.webp 582w"],
                "sizes": "(max-width: 582px) 100vw, 582px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/387f46d55f3c404b6e8747502b2def56/e92b6/techletter.app-screenshot-1573495144942.png 223w", "/static/387f46d55f3c404b6e8747502b2def56/e66bf/techletter.app-screenshot-1573495144942.png 445w", "/static/387f46d55f3c404b6e8747502b2def56/7c1cd/techletter.app-screenshot-1573495144942.png 582w"],
                "sizes": "(max-width: 582px) 100vw, 582px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/387f46d55f3c404b6e8747502b2def56/7c1cd/techletter.app-screenshot-1573495144942.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`That gives my entire app access to GraphQL for a specific server. Using `}<a parentName="p" {...{
        "href": "https://swapi.co/"
      }}>{`Star Wars API`}</a>{` for this example.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2Fapollo.js%0A%0Aimport%20ApolloClient%20from%20%22apollo-boost%22%0Aimport%20fetch%20from%20%22isomorphic-fetch%22%0A%0Aconst%20SERVER_URI%20%3D%0A%20%20%20%20%22https%3A%2F%2Fapi.graphcms.com%2Fsimple%2Fv1%2Fswapi%22%0A%0Aexport%20const%20client%20%3D%20new%20ApolloClient(%7B%0A%20%20%20%20uri%3A%20SERVER_URI%2C%0A%20%20%20%20fetch%2C%0A%7D)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "470px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "82.0627802690583%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'328\\'%20viewBox=\\'0%200%20400%20328\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M29%2043c-3%202-3%20241%200%20243%202%203%20340%203%20342%200%203-2%203-241%200-243-2-3-340-3-342%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3420861e42a132f6a73b9bcf0470c199/ca0a1/techletter.app-screenshot-1573495144760.webp 223w", "/static/3420861e42a132f6a73b9bcf0470c199/75680/techletter.app-screenshot-1573495144760.webp 445w", "/static/3420861e42a132f6a73b9bcf0470c199/4424c/techletter.app-screenshot-1573495144760.webp 470w"],
                "sizes": "(max-width: 470px) 100vw, 470px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3420861e42a132f6a73b9bcf0470c199/e92b6/techletter.app-screenshot-1573495144760.png 223w", "/static/3420861e42a132f6a73b9bcf0470c199/e66bf/techletter.app-screenshot-1573495144760.png 445w", "/static/3420861e42a132f6a73b9bcf0470c199/f96db/techletter.app-screenshot-1573495144760.png 470w"],
                "sizes": "(max-width: 470px) 100vw, 470px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3420861e42a132f6a73b9bcf0470c199/f96db/techletter.app-screenshot-1573495144760.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "loading-additional-data-on-render"
    }}>{`Loading additional data on render`}</h2>
    <p>{`Once you have "cached" data baked into your HTML and the ability to load fresh data on render, you're presented with a dilemma.`}</p>
    <blockquote>
      <p parentName="blockquote">{`How do I show static data, communicate that more data is loading, and show fresh data when I've got it? If the user is offline, what then?`}</p>
    </blockquote>
    <p>{`Those are tough problems. Traditionally, you'd render a component, show a spinner, fetch more data after render, then re-render once done.`}</p>
    <p>{`Something like this (this is pseudocode):`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20STARSHIP_QUERY%20%3D%20gql%60%0A%20%20query%20starships(%24count%3A%20Int)%20%7B%0A%20%20%20%20allStarships(last%3A%20%24count)%20%7B%0A%20%20%20%20%20%20name%0A%20%20%20%20%7D%0A%20%20%7D%0A%60%0A%0Afunction%20StarshipList(%7B%20data%20%7D)%20%7B%0A%09const%20%7B%20loading%2C%20data%20%7D%20%3D%20useQuery(STARSHIP_QUERY%2C%20%7B%0A%09%09variables%3A%20%7B%0A%09%09%09count%3A%2015%0A%09%09%7D%0A%09%7D)%0A%09%0A%09return%20%3Cdiv%3E%0A%09%09%7Bloading%20%3F%20%22Loading%20more%22%20%3A%20null%7D%0A%09%09%3Cul%3E%0A%09%09%09%7Bdata.list.map(ship%20%3D%3E%20%3Cli%3E%7Bship.name%7D%3C%2Fli%3E)%7D%0A%09%09%3C%2Ful%3E%0A%09%3C%2Fdiv%3E%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "558px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "101.34529147982063%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'405\\'%20viewBox=\\'0%200%20400%20405\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2035c-3%202-3%20335%200%20336h350c3-1%203-334%200-336H25\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5df99985818573da874934e3c190cf04/ca0a1/techletter.app-screenshot-1573495144730.webp 223w", "/static/5df99985818573da874934e3c190cf04/75680/techletter.app-screenshot-1573495144730.webp 445w", "/static/5df99985818573da874934e3c190cf04/1c397/techletter.app-screenshot-1573495144730.webp 558w"],
                "sizes": "(max-width: 558px) 100vw, 558px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5df99985818573da874934e3c190cf04/e92b6/techletter.app-screenshot-1573495144730.png 223w", "/static/5df99985818573da874934e3c190cf04/e66bf/techletter.app-screenshot-1573495144730.png 445w", "/static/5df99985818573da874934e3c190cf04/42a8d/techletter.app-screenshot-1573495144730.png 558w"],
                "sizes": "(max-width: 558px) 100vw, 558px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/5df99985818573da874934e3c190cf04/42a8d/techletter.app-screenshot-1573495144730.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><inlineCode parentName="p">{`STARSHIP_QUERY`}</inlineCode>{` is a GraphQL query that returns a list of `}<inlineCode parentName="p">{`$count`}</inlineCode>{` starships from StarWarsApi, `}<inlineCode parentName="p">{`swapi`}</inlineCode>{` for short.`}</p>
    <p><inlineCode parentName="p">{`useQuery`}</inlineCode>{` runs the query and returns a loading state and data.`}</p>
    <p>{`Component renders the loading notification and a list of starships from props. Those were baked in at build time. When fresh data arrives from our API call, the component re-renders.`}</p>
    <p>{`You can tell this is pseudocode because I'm re-defining the `}<inlineCode parentName="p">{`data`}</inlineCode>{` constant and that won't work :)`}</p>
    <h2 {...{
      "id": "using-react-suspense-instead"
    }}>{`Using React Suspense instead`}</h2>
    <p>{`With React Suspense, you can make that API call preemptively. While the page is loading.`}</p>
    <p>{`Some background on how that works in last week's `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/experimenting-with-the-new-react-concurrent-mode/swizec/9231"
      }}>{`Experimenting with the new React Concurrent mode`}</a>{` article ✌️`}</p>
    <p>{`Here's how you might set it up for Gatsby. Or at least how I did.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20pages%2Findex.js%0A%0Aimport%20%7B%20starshipQuery%2C%20ErrorBoundary%20%7D%20from%20%22..%2Futil%22%0A%0A%2F%2F%20Export%20static%20query%20for%20Gatsby%0Aexport%20const%20query%20%3D%20graphql%60%0A%20%20query%20%7B%0A%20%20%20%20swapi%20%7B%0A%20%20%20%20%20%20allStarships(last%3A%205)%20%7B%0A%20%20%20%20%20%20%20%20name%0A%20%20%20%20%20%20%7D%0A%20%20%20%20%7D%0A%20%20%7D%0A%60%0A%0A%2F%2F%20Run%20query%20on%20browser%20hydration%0Aconst%20starshipQuerySuspender%20%3D%20starshipQuery(10)%0A%0A%2F%2F%20The%20component%20that%20suspends%20with%20a%20data%20load%0Aconst%20Starships%20%3D%20()%20%3D%3E%20%7B%0A%20%20const%20starships%20%3D%20starshipQuerySuspender.read()%0A%0A%20%20return%20%3CStarshipsList%20list%3D%7Bstarships%7D%20title%3D%2210%20Dynamically%20loaded%20ships%22%20%2F%3E%0A%7D%0A%0A%2F%2F%20Wrapper%20component%20with%20a%20title%20and%20a%20list%0Aconst%20StarshipsList%20%3D%20(%7B%20list%2C%20title%20%7D)%20%3D%3E%20(%0A%20%20%3C%3E%0A%20%20%20%20%3Ch2%3E%7Btitle%7D%3C%2Fh2%3E%0A%20%20%20%20%3Cul%3E%0A%20%20%20%20%20%20%7Blist.allStarships.map((ship%2C%20i)%20%3D%3E%20(%0A%20%20%20%20%20%20%20%20%3Cli%20key%3D%7Bi%7D%3E%7Bship.name%7D%3C%2Fli%3E%0A%20%20%20%20%20%20))%7D%0A%20%20%20%20%3C%2Ful%3E%0A%20%20%3C%2F%3E%0A)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "734px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "111.21076233183858%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'445\\'%20viewBox=\\'0%200%20400%20445\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M18%2028c-2%204-1%20388%201%20390%202%203%20360%203%20362%200%202-2%203-386%201-390-2-3-362-3-364%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/aefa86cfd73655d4076645d66febd07c/ca0a1/techletter.app-screenshot-1573495144991.webp 223w", "/static/aefa86cfd73655d4076645d66febd07c/75680/techletter.app-screenshot-1573495144991.webp 445w", "/static/aefa86cfd73655d4076645d66febd07c/a242a/techletter.app-screenshot-1573495144991.webp 734w"],
                "sizes": "(max-width: 734px) 100vw, 734px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/aefa86cfd73655d4076645d66febd07c/e92b6/techletter.app-screenshot-1573495144991.png 223w", "/static/aefa86cfd73655d4076645d66febd07c/e66bf/techletter.app-screenshot-1573495144991.png 445w", "/static/aefa86cfd73655d4076645d66febd07c/c6d67/techletter.app-screenshot-1573495144991.png 734w"],
                "sizes": "(max-width: 734px) 100vw, 734px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/aefa86cfd73655d4076645d66febd07c/c6d67/techletter.app-screenshot-1573495144991.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`All this goes in the `}<inlineCode parentName="p">{`index.js`}</inlineCode>{` page. The first page you see in a Gatsby app.`}</p>
    <p>{`We start with a static page query for Gatsby. This one runs at build-time and bakes data into our HTML. I tried having a shared query between Gatsby and Apollo, but the `}<inlineCode parentName="p">{`graphql`}</inlineCode>{` (gatsby) and `}<inlineCode parentName="p">{`gql`}</inlineCode>{` (apollo) tags are not compatible.`}</p>
    <p>{`Then we've got the `}<inlineCode parentName="p">{`starshipQuerySuspender`}</inlineCode>{`, which runs in the browser when Gatsby turns this page into a JavaScript app.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`<Starships>`}</inlineCode>{` component suspends with a data load and renders `}<inlineCode parentName="p">{`<StarshipsList>`}</inlineCode>{` when data shows up. The static page is going to render this same component with its data.`}</p>
    <h3 {...{
      "id": "page-render-with-suspendering"
    }}>{`Page render with suspendering`}</h3>
    <p>{`In the `}<inlineCode parentName="p">{`IndexPage`}</inlineCode>{` component we can then use `}<inlineCode parentName="p">{`<Suspense>`}</inlineCode>{` to coordinate loading and error states.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20pages%2Findex.js%0A%0Aconst%20IndexPage%20%3D%20(%7B%20data%20%7D)%20%3D%3E%20(%0A%09%2F%2F%20...%0A%09%3CSuspense%0A%20%20%20%20%20%20fallback%3D%7B%0A%20%20%20%20%20%20%20%20%3CStarshipsList%0A%20%20%20%20%20%20%20%20%20%20list%3D%7Bdata.swapi%7D%0A%20%20%20%20%20%20%20%20%20%20title%3D%22Statically%20compiled%20starships%22%0A%20%20%20%20%20%20%20%20%2F%3E%0A%20%20%20%20%20%20%7D%0A%20%20%20%20%3E%0A%20%20%20%20%20%20%3CErrorBoundary%0A%20%20%20%20%20%20%20%20fallback%3D%7B%0A%20%20%20%20%20%20%20%20%20%20%3CStarshipsList%0A%20%20%20%20%20%20%20%20%20%20%20%20list%3D%7Bdata.swapi%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20title%3D%22Failed%20to%20fetch%2C%20these%20are%20static%22%0A%20%20%20%20%20%20%20%20%20%20%2F%3E%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%3E%0A%20%20%20%20%20%20%20%20%3CStarships%20%2F%3E%0A%20%20%20%20%20%20%3C%2FErrorBoundary%3E%0A%20%20%20%20%3C%2FSuspense%3E%0A)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "526px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "114.34977578475336%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'457\\'%20viewBox=\\'0%200%20400%20457\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2038c-2%202-1%20380%201%20382%201%201%2029%202%20174%202s173-1%20174-2c2-2%203-380%201-382S27%2036%2025%2038\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/04a5a6b6be3b0a1575db9210463c6ebc/ca0a1/techletter.app-screenshot-1573495144911.webp 223w", "/static/04a5a6b6be3b0a1575db9210463c6ebc/75680/techletter.app-screenshot-1573495144911.webp 445w", "/static/04a5a6b6be3b0a1575db9210463c6ebc/9752a/techletter.app-screenshot-1573495144911.webp 526w"],
                "sizes": "(max-width: 526px) 100vw, 526px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/04a5a6b6be3b0a1575db9210463c6ebc/e92b6/techletter.app-screenshot-1573495144911.png 223w", "/static/04a5a6b6be3b0a1575db9210463c6ebc/e66bf/techletter.app-screenshot-1573495144911.png 445w", "/static/04a5a6b6be3b0a1575db9210463c6ebc/2d7ab/techletter.app-screenshot-1573495144911.png 526w"],
                "sizes": "(max-width: 526px) 100vw, 526px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/04a5a6b6be3b0a1575db9210463c6ebc/2d7ab/techletter.app-screenshot-1573495144911.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Our Gatsby page gets static data via the `}<inlineCode parentName="p">{`data`}</inlineCode>{` prop. This works offline too, `}<a parentName="p" {...{
        "href": "https://gatsby-suspense-poc.now.sh/"
      }}>{`you can try, here`}</a>{` 👌`}</p>
    <p>{`Here's where the fun starts:`}</p>
    <p><inlineCode parentName="p">{`Suspense`}</inlineCode>{` sees that we're running a GraphQL query (the suspender.read()) so it renders the `}<inlineCode parentName="p">{`fallback`}</inlineCode>{` render prop. But that prop uses our static data to render a list of 5 starships. It's not all of them, but it's better than nothing.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/cbdfb2f1383bb21750127d035019daa8/062c8/1tK5XvC.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.15695067264574%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'220\\'%20viewBox=\\'0%200%20400%20220\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M221%2047c0%203%200%204-2%204-1%200-2-1-1-2%200-2%200-2-1%200l-2%202v-3c-1-4-6-4-5%200%200%203%200%203-1%202l-1-3v-1c-1-1-1%200-1%202l-1%203v-2l-1-3v1c0%202-2%203-3%202l1-3v-1l-1%203c0%202-1%203-2%203l-2-1v-2c0-1%200-2-1-1l-1%202v2l-1-1h-9l-1-2v-2l-2%202c-1%202-1%202-2%201s-1-1-2%201c0%201-1%201-1-1-1-4-4-5-4-2h1c1-2%202%200%202%203h-3c0-3-2-5-3-3h-1l-1-2-1%201a768%20768%200%2001-2%201c-1-1-2-1-2%202v3h35a234%20234%200%200033-2l-1-2c0-1%200-2-1-1v2l-1%202-1-5c-1-3-1-3-1%201%200%203%200%204-2%204v-4c-1-1-1-1-1%201l-1%202v-4l-1-2c-1-1-1%200-1%203\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/cbdfb2f1383bb21750127d035019daa8/ca0a1/1tK5XvC.webp 223w", "/static/cbdfb2f1383bb21750127d035019daa8/75680/1tK5XvC.webp 445w", "/static/cbdfb2f1383bb21750127d035019daa8/8d1ba/1tK5XvC.webp 890w", "/static/cbdfb2f1383bb21750127d035019daa8/3838e/1tK5XvC.webp 1335w", "/static/cbdfb2f1383bb21750127d035019daa8/df861/1tK5XvC.webp 1386w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/cbdfb2f1383bb21750127d035019daa8/e92b6/1tK5XvC.png 223w", "/static/cbdfb2f1383bb21750127d035019daa8/e66bf/1tK5XvC.png 445w", "/static/cbdfb2f1383bb21750127d035019daa8/4ef49/1tK5XvC.png 890w", "/static/cbdfb2f1383bb21750127d035019daa8/4e814/1tK5XvC.png 1335w", "/static/cbdfb2f1383bb21750127d035019daa8/062c8/1tK5XvC.png 1386w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/cbdfb2f1383bb21750127d035019daa8/4ef49/1tK5XvC.png",
              "alt": "1tK5XvC",
              "title": "1tK5XvC",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Even if it all goes to shit, our user gets the most important data they're looking for.`}</p>
    <p>{`Once our query finishes, Suspense renders the main list. Now with fresh data from the API.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/402e9a916fbcb7a5c64d6e243c02cfd9/c8ad9/29zAunt.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.6457399103139%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'291\\'%20viewBox=\\'0%200%20400%20291\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M208%2040c1%204%200%204-2%204s-3-1-3-3l-1-2v3l-1%202-1-2c0-2-1-3-2-3l-2%202c0%203-1%203-7%202l-1-2-1-1v2c0%201-1%202-4%201-5%200-6%200-6-2h2l2%201c0-2-4-4-5-2h-1l-1-1-2%201c1%202%200%203-1%201s-4-3-4-1l1%201c1-1%201%200%201%201%200%203-1%202-3-1l-1-2%201%202c0%203-2%204-2%201h-1l-1%202-1-1-1-2v1l-1%201h-1a256%20256%200%200063%201l2%202v-2h2l-1-1v-1l1-2c0-2-4-1-4%200h-1l-2-1v4l-1-1c-1-1-1-1%200%200l-1%202-1-3-1-4v4l-1%203v-2l-2-3c-3-3-3-3-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/402e9a916fbcb7a5c64d6e243c02cfd9/ca0a1/29zAunt.webp 223w", "/static/402e9a916fbcb7a5c64d6e243c02cfd9/75680/29zAunt.webp 445w", "/static/402e9a916fbcb7a5c64d6e243c02cfd9/8d1ba/29zAunt.webp 890w", "/static/402e9a916fbcb7a5c64d6e243c02cfd9/3838e/29zAunt.webp 1335w", "/static/402e9a916fbcb7a5c64d6e243c02cfd9/156b8/29zAunt.webp 1564w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/402e9a916fbcb7a5c64d6e243c02cfd9/e92b6/29zAunt.png 223w", "/static/402e9a916fbcb7a5c64d6e243c02cfd9/e66bf/29zAunt.png 445w", "/static/402e9a916fbcb7a5c64d6e243c02cfd9/4ef49/29zAunt.png 890w", "/static/402e9a916fbcb7a5c64d6e243c02cfd9/4e814/29zAunt.png 1335w", "/static/402e9a916fbcb7a5c64d6e243c02cfd9/c8ad9/29zAunt.png 1564w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/402e9a916fbcb7a5c64d6e243c02cfd9/4ef49/29zAunt.png",
              "alt": "29zAunt",
              "title": "29zAunt",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`That `}<inlineCode parentName="p">{`<ErrorBoundary>`}</inlineCode>{` gives us an extra feature: We can show something useful even if the user is offline and our query fails.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/1930a2288d18b8a2ae8a8fc78a19ba6a/add4c/vKX8As1.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.569506726457405%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'206\\'%20viewBox=\\'0%200%20400%20206\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M205%2043c0%203%200%204-2%204l-1-3%201-2-1%203c-2%203-2%203-3-2-1-3-4-1-4%202%200%202%200%202-1%201v-3l-1-1-1%203-1%202v-2l-1-3v1l-1%202c-1%201-1%200-1-1s0-2-1-1l-1%202c1%203-1%202-3-1l-1-2v5l-1-1h-1c-2%201-4%200-4-2s-1-2-4-1l2%202%201%202c-2%200-3-2-4-3l-1-2v5c-1%200-2-3-1-4l-2-1c-1%200-2%200-1%201l-1%203-1-2c-1-2-1-2-1%200%200%203%200%203-5%203l-4-1-1-2c-2-2-2-2-2%201v3h33l33-1-1-1-1-2c0-1%200-2-1-1v2l-1%202-1-5c-1-3-1-3-1%201l-1%204v-2l-1-3v1l-1%202c-1%201-1%200-1-2l-1-4-1%204\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/1930a2288d18b8a2ae8a8fc78a19ba6a/ca0a1/vKX8As1.webp 223w", "/static/1930a2288d18b8a2ae8a8fc78a19ba6a/75680/vKX8As1.webp 445w", "/static/1930a2288d18b8a2ae8a8fc78a19ba6a/8d1ba/vKX8As1.webp 890w", "/static/1930a2288d18b8a2ae8a8fc78a19ba6a/3838e/vKX8As1.webp 1335w", "/static/1930a2288d18b8a2ae8a8fc78a19ba6a/78e5d/vKX8As1.webp 1452w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/1930a2288d18b8a2ae8a8fc78a19ba6a/e92b6/vKX8As1.png 223w", "/static/1930a2288d18b8a2ae8a8fc78a19ba6a/e66bf/vKX8As1.png 445w", "/static/1930a2288d18b8a2ae8a8fc78a19ba6a/4ef49/vKX8As1.png 890w", "/static/1930a2288d18b8a2ae8a8fc78a19ba6a/4e814/vKX8As1.png 1335w", "/static/1930a2288d18b8a2ae8a8fc78a19ba6a/add4c/vKX8As1.png 1452w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/1930a2288d18b8a2ae8a8fc78a19ba6a/4ef49/vKX8As1.png",
              "alt": "vKX8As1",
              "title": "vKX8As1",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Same fallback to static data, now with a warning that you're offline ✌️`}</p>
    <h2 {...{
      "id": "where-im-stuck-subsequent-pages"
    }}>{`Where I'm stuck: subsequent pages`}</h2>
    <p>{`Now that approach works great, if your site has a single page. Where it breaks down are multi-page sites. Which is most of them.`}</p>
    <p>{`I tried replicating the same code on `}<inlineCode parentName="p">{`page-2.js`}</inlineCode>{` and this happens:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/2554fb36b377924d8745e445b602bf1a/4ef49/JUHvLjC.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "35.874439461883405%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'144\\'%20viewBox=\\'0%200%20400%20144\\'%20preserveAspectRatio=\\'none\\'/%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/2554fb36b377924d8745e445b602bf1a/ca0a1/JUHvLjC.webp 223w", "/static/2554fb36b377924d8745e445b602bf1a/75680/JUHvLjC.webp 445w", "/static/2554fb36b377924d8745e445b602bf1a/8d1ba/JUHvLjC.webp 890w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/2554fb36b377924d8745e445b602bf1a/e92b6/JUHvLjC.png 223w", "/static/2554fb36b377924d8745e445b602bf1a/e66bf/JUHvLjC.png 445w", "/static/2554fb36b377924d8745e445b602bf1a/4ef49/JUHvLjC.png 890w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/2554fb36b377924d8745e445b602bf1a/4ef49/JUHvLjC.png",
              "alt": "JUHvLjC",
              "title": "JUHvLjC",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Two `}<inlineCode parentName="p">{`swapi`}</inlineCode>{` requests on initial page load. Makes subsequent pages crazy fast with no hint of data loading, but means that you're `}<em parentName="p">{`loading data for your whole website on initial load`}</em>{`.`}</p>
    <p>{`That just won't do. We need to hook into the router's lifecycle. Gatsby uses `}<a parentName="p" {...{
        "href": "https://github.com/reach/router"
      }}>{`@reach/router`}</a>{` by the way.`}</p>
    <p>{`And that's where I'm stuck. Tried a few things, none worked.`}</p>
    <h3 {...{
      "id": "suspend-on-render-nope"
    }}>{`Suspend on render, nope`}</h3>
    <p>{`Loading on render was slow as heck:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=dataSuspender%20%3D%20()%20%3D%3E%20starshipQuerySuspender(15)%0A%3CStarships%20data%3D%7BdataSuspender()%7D%20%2F%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "486px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "42.152466367713004%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'169\\'%20viewBox=\\'0%200%20400%20169\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2042c-2%203-1%2084%200%2087%203%203%20343%203%20346%200%201-3%202-84%200-87S29%2039%2027%2042\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bab2e748b1cd93dd8a1c80483daa4632/ca0a1/techletter.app-screenshot-1573495144848.webp 223w", "/static/bab2e748b1cd93dd8a1c80483daa4632/75680/techletter.app-screenshot-1573495144848.webp 445w", "/static/bab2e748b1cd93dd8a1c80483daa4632/aba12/techletter.app-screenshot-1573495144848.webp 486w"],
                "sizes": "(max-width: 486px) 100vw, 486px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bab2e748b1cd93dd8a1c80483daa4632/e92b6/techletter.app-screenshot-1573495144848.png 223w", "/static/bab2e748b1cd93dd8a1c80483daa4632/e66bf/techletter.app-screenshot-1573495144848.png 445w", "/static/bab2e748b1cd93dd8a1c80483daa4632/4ee7f/techletter.app-screenshot-1573495144848.png 486w"],
                "sizes": "(max-width: 486px) 100vw, 486px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/bab2e748b1cd93dd8a1c80483daa4632/4ee7f/techletter.app-screenshot-1573495144848.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Worked but just as slow as running a query without Suspense.`}</p>
    <h3 {...{
      "id": "pass-suspender-as-link-state-nah"
    }}>{`Pass suspender as link state, nah`}</h3>
    <p>{`Reach Router lets you pass state to pages with a `}<inlineCode parentName="p">{`state`}</inlineCode>{` prop in your `}<inlineCode parentName="p">{`<Link>`}</inlineCode>{` component. Whatever you pass shows up in the `}<inlineCode parentName="p">{`location`}</inlineCode>{` prop on the target component.`}</p>
    <p>{`Works great for static values, but did not work with this approach:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%3CLink%0A%20%20to%3D%22%2Fpage-2%22%0A%20%20state%3D%7B%7B%0A%20%20%20%20starshipQuerySuspender%3A%20()%20%3D%3E%20starshipQuery(15)%2C%20%2F%2F%20didnt%20work%0A%20%20%7D%7D%0A%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "630px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "43.946188340807176%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'176\\'%20viewBox=\\'0%200%20400%20176\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2033a1385%201385%200%20001%20112c2%202%20354%202%20356%200%202-1%202-6%202-56l-1-56c-1-3-357-3-358%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cae4a935fd3d41f424d526b1581d16a5/ca0a1/techletter.app-screenshot-1573495144824.webp 223w", "/static/cae4a935fd3d41f424d526b1581d16a5/75680/techletter.app-screenshot-1573495144824.webp 445w", "/static/cae4a935fd3d41f424d526b1581d16a5/8aab1/techletter.app-screenshot-1573495144824.webp 630w"],
                "sizes": "(max-width: 630px) 100vw, 630px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cae4a935fd3d41f424d526b1581d16a5/e92b6/techletter.app-screenshot-1573495144824.png 223w", "/static/cae4a935fd3d41f424d526b1581d16a5/e66bf/techletter.app-screenshot-1573495144824.png 445w", "/static/cae4a935fd3d41f424d526b1581d16a5/f058b/techletter.app-screenshot-1573495144824.png 630w"],
                "sizes": "(max-width: 630px) 100vw, 630px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/cae4a935fd3d41f424d526b1581d16a5/f058b/techletter.app-screenshot-1573495144824.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Not sure why, but trying to pass a function made the whole state value `}<inlineCode parentName="p">{`null`}</inlineCode>{`.`}</p>
    <h3 {...{
      "id": "hook-into-onprerouteupdate-nyet"
    }}>{`Hook into onPreRouteUpdate, nyet`}</h3>
    <p>{`Another approach I tried was using Gatsby's browser APIs. You can hook into various parts of the page lifecycle with special methods in `}<inlineCode parentName="p">{`gatsby-browser.js`}</inlineCode>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=export%20const%20onRouteUpdate%20%3D%20(%7B%20location%20%7D)%20%3D%3E%20%7B%0A%20%20%2F%2F%20this%20feels%20brittle%0A%20%20if%20(location.pathname%20%3D%3D%3D%20%22%2Fpage-2%22)%20%7B%0A%20%20%20%20%2F%2F%20this%20works%20but%20data%20shows%20up%20in%20location%20prop%20_after_%20the%20page%20is%20rendered%0A%20%20%20%20location.dataSuspender%20%3D%20starshipQuery(15)%0A%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "750px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "39.46188340807175%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'157\\'%20viewBox=\\'0%200%20400%20157\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M18%2026l-1%2054%201%2052h365V80l-1-54c-2-2-362-2-364%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c4fece5f09d3f8727d3b029e707128f5/ca0a1/techletter.app-screenshot-1573495144669.webp 223w", "/static/c4fece5f09d3f8727d3b029e707128f5/75680/techletter.app-screenshot-1573495144669.webp 445w", "/static/c4fece5f09d3f8727d3b029e707128f5/08b4d/techletter.app-screenshot-1573495144669.webp 750w"],
                "sizes": "(max-width: 750px) 100vw, 750px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c4fece5f09d3f8727d3b029e707128f5/e92b6/techletter.app-screenshot-1573495144669.png 223w", "/static/c4fece5f09d3f8727d3b029e707128f5/e66bf/techletter.app-screenshot-1573495144669.png 445w", "/static/c4fece5f09d3f8727d3b029e707128f5/1d69c/techletter.app-screenshot-1573495144669.png 750w"],
                "sizes": "(max-width: 750px) 100vw, 750px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c4fece5f09d3f8727d3b029e707128f5/1d69c/techletter.app-screenshot-1573495144669.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Thought I could manipulate the `}<inlineCode parentName="p">{`location`}</inlineCode>{` prop passed into a page and I can, sort of.`}</p>
    <p>{`When you console.log that value, it shows that you successfully passed the `}<inlineCode parentName="p">{`dataSuspender`}</inlineCode>{`. This was great news until I realized that data shows up `}<em parentName="p">{`after`}</em>{` the page renders.`}</p>
    <p>{`How do I know?`}</p>
    <p>{`Because `}<inlineCode parentName="p">{`console.log(location)`}</inlineCode>{` shows the value, but `}<inlineCode parentName="p">{`console.log(location.dataSuspender)`}</inlineCode>{` prints undefined. Means the value isn't there when you're printing, but does show up later. Hooray for console.log being dynamic and always showing current object state.`}</p>
    <h2 {...{
      "id": "i-tried"
    }}>{`I tried`}</h2>
    <p><img parentName="p" {...{
        "src": "/ad0cbefaf2d0fc7e060c2a9cff4e0189/media-bqXMrwkWhAbrV0Z0dG-giphy.gif",
        "alt": "I_tried giphy"
      }}></img></p>
    <p>{`I tried everything I could think of. Some of this stuff is either a bug in Gatsby, a bug in `}<a parentName="p" {...{
        "href": "https://twitter.com/reach"
      }}>{`@reach`}</a>{`/router, or just not meant to work this way by design.`}</p>
    <p>{`Next step: bug people online to find out 😛`}</p>
    <p>{`Happy Monday, ~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      